import type { Institution, Pagination, SimplePatientList } from "@shared/models";


export interface BasicDoctor {
	id: number;
	firstName: string;
	lastName: string;
}
export interface Doctor {
	id?: number
	medic_id?: number
	firstname: string,
	lastname: string,
	email: string,
	id_number: number | null,
	phone_number: number | null,
	profile: string
}

export interface FetchDoctor {
	firstname: string,
	lastname: string,
	email: string,
	id_number: number | null,
	phone_number: number | null,
	profile: string,
	address: string,
	region: string,
	region_id: number,
	institutions: Institution[],
	products: number[];
	operatesIn: number;
	company_id: number;
	company: string;
	linkedPatients: SimplePatientList[];
}

export interface FetchDoctorsQueryParam {
	page: string | number;
	id: string | number;
	medic_id: string | number;
	fullname: string;
	email: string;
	profile: 'medico';
	commerce: 'Argentina' | 'COMEX';
	order_by: string;
	order_direction: 'asc' | 'desc';
	per_page: number | string;
}

export interface DoctorsListResponse {
	status: boolean;
	data: DoctorListItem[];
	pagination: Pagination;
}

export interface DoctorListItem {
	id: number | null;
	medic_id: number | null;
	firstname: string;
	lastname: string;
	email: string;
	type: string;
	status: string;
}

export interface DoctorResponse {
	message: string
	data: FetchDoctor
}

export interface DoctorPatientResponse {
	id: number | null;
	medic_id: number | null;
	fullname: string;
	patient_ids: DoctorPatient[];
}
export interface DoctorPatient {
	patient_id: number;
}

export interface SimpleDoctor {
	id: number,
	fullname: string
}

export interface MedicSimpleListResponse {
	status: boolean;
	message: string;
	data: MedicSimpleList[];
	pagination: Pagination | null;
}

export interface MedicSimpleList {
	id: number,
	medic_id: number;
	fullname: string;
}

